// Permission keys for the Account page, and how the UI recognises a sync-created billing contact.

// Any one opens the Account page where it already exists.
export const ACCOUNT_PAGE_PERMISSION_KEYS = [
  'manage_account',
  'view_account',
  'purchase_shippable',
  'purchase_add_ons',
  'change_subscription_payment_methods',
  'administer_account',
]

// The Orders tab, and /facility/crmAccount/, which aroya-be opens to exactly these. Never view_account.
export const ORDER_VIEW_PERMISSION_KEYS = [
  'manage_account',
  'administer_account',
  'purchase_shippable',
  'purchase_add_ons',
]

// Keys the Salesforce sync gives a facility's invoicing contact and its contract holder's.
export const SYNC_CONTACT_PERMISSION_KEYS = ['administer_account', 'change_subscription_payment_methods']

type KeyedMembership = { readonly permissions?: readonly string[] } | null | undefined

// A billing contact the sync created or keyed.
export const isSyncContact = (membership: KeyedMembership): boolean =>
  SYNC_CONTACT_PERMISSION_KEYS.some(key => Boolean(membership?.permissions?.includes(key)))

// What "Select User" grants and a chip's delete revokes, always together.
export const PURCHASE_PERMISSION_KEYS = ['purchase_shippable', 'purchase_add_ons']
